import React, {Fragment, useState} from 'react'// eslint-disable-line
import clsx from 'clsx';
import {createUseStyles} from 'react-jss';
import {COLORS} from '../../utils/style-variables';
import {ErrorMessage} from '../common/errorMessage';
import {
  SORT_ASC_SELL,
  SORT_ASC_BUY,
  SORT_DESC_SELL,
  SORT_DESC_BUY,
  FETCH_BRANCHES_PENDING, FETCH_BRANCHES_SUCCESS, FETCH_BRANCHES_ERROR
} from '../../utils/action-types';
import apiEntryPoint from '../../api/apiSingleton';
import {TableRow} from './table-row';
import {Branches} from './branches';
import {banksTableStyles, TABLE} from '../../common-styles/style-table';
import {getKzDateTime} from '../../utils/helpers';
import {TEXT} from '../../common-styles/typography-style';
import {sortIcon} from '../../common-styles/icons-style';

const useStyles = createUseStyles({
  table: {
    ...TEXT.defaultSize
  },
  tableHeader: {
    extend: TABLE.row,
    borderWidth: 1,
    borderTopStyle: 'solid',
    borderColor: COLORS.lightGrey30Color,
    backgroundColor: COLORS.backgroundGreyColor,
    color: COLORS.greyColor,
    userSelect: 'none'
  },
  tableBody: {
    position: 'relative',
    minHeight: 57,
    '@media (max-width: 768px)': {
      minHeight: 57
    }
  },
  ...banksTableStyles,
  sortable: {
    cursor: 'pointer',
    extend: sortIcon
  },
  '@media (max-width: 768px)': {
    tableBranchColumn: {
      width: 0
    },
    sortable: {
      paddingRight: 10
    }

  },
  toggleMore: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 24,
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '15px',
    lineHeight: '20px',
    color: COLORS.greyColor,
    '& p': {
      cursor: 'pointer',
      transition: 'opacity 0.250s ease-in-out',
      textDecoration: 'underline',
      '&:hover': {
        opacity: 0.5
      }
    }
  }
});

const renderTableBody = (data, savedBranches, currency, selectedLocation, dispatch) => {

  const [openBranches, setOpenBranches] = useState([]);
  const toggleBranch = (bank, platform) => {
    if (!platform || !bank.hasBranches) {
      return;
    }
    if (openBranches.find(elem => elem.id === bank.bankId && elem.city === selectedLocation.key)) {
      setOpenBranches(openBranches.filter(e => e.id !== bank.bankId));
    } else {
      const storedBranch = savedBranches.find(branchData =>
        branchData.id === bank.bankId && branchData.city === selectedLocation.key);

      if (storedBranch) {
        setOpenBranches([...openBranches, {...storedBranch}]);
      } else {
        dispatch({
          type: FETCH_BRANCHES_PENDING
        });
        apiEntryPoint.finance.bankBranches(bank.bankId, {city: selectedLocation.key}).then(branches => {
          dispatch({
            type: FETCH_BRANCHES_SUCCESS,
            payload: {id: bank.bankId, city: selectedLocation.key, branches}
          });
          setOpenBranches([...openBranches, {id: bank.bankId, city: selectedLocation.key, branches}]);
        }).catch(() => dispatch({
          type: FETCH_BRANCHES_ERROR
        }));
      }
    }
  };

  return data.map(bank => {
    const bankBranches = openBranches.find(e => e.id === bank.bankId && e.city === selectedLocation.key) || {};

    return (
      <Fragment key={bank.bankId}>
        <TableRow
          bank={bank}
          toggleBranch={toggleBranch}
          openDropdown={bankBranches.city === selectedLocation.key}
        />

        {bankBranches.city === selectedLocation.key ?
          <Branches data={{bank, bankBranches, selectedLocation}} />
          :
          null}
      </Fragment>
    );
  });
};

export const BanksTable = ({dispatch, state}) => {
  const classes = useStyles();
  const {data, value: currency, lastModified, isError, sorted, selectedLocation, savedBranches} = state;

  const handleSellSort = () => {
    switch (sorted) {
      case 'sell_asc':
        dispatch({type: SORT_DESC_SELL});
        break;
      case 'sell_desc':
      default:
        dispatch({type: SORT_ASC_SELL});
        break;
    }
  };
  const handleBuySort = () => {
    switch (sorted) {
      case 'buy_asc':
        dispatch({type: SORT_DESC_BUY});
        break;
      case 'buy_desc':
      default:
        dispatch({type: SORT_ASC_BUY});
        break;
    }
  };

  return (
    <Fragment>
      <div className={classes.table}>
        <div className={classes.tableHeader}>
          <div
            className={clsx(classes.tableColumn, classes.tableNameColumn)}
          >Банк/Пункт Обмена
          </div>
          <div
            className={clsx(classes.tableColumn,
              classes.tableBuyColumn,
              classes.sortable,
              sorted)}
            onClick={handleBuySort}
          >Покупка
          </div>
          <div
            className={clsx(classes.tableColumn,
              classes.tableSellColumn,
              classes.sortable,
              sorted)}
            onClick={handleSellSort
            }
          >Продажа
          </div>
          <div
            className={clsx(classes.tableColumn, classes.tableUpdateColumn)}
          >Обновлено
          </div>
          <div className={clsx(classes.tableColumn, classes.tableBranchColumn)} />
        </div>
        <div className={classes.tableBody}>
          {isError || !data.length ?
            <ErrorMessage />
            :
            renderTableBody(data, savedBranches, currency, selectedLocation, dispatch)
          }
        </div>
      </div>
      <div className={classes.toggleMore}>
        {data.length ?
          <span>
            Обновлено в <time dateTime={getKzDateTime(lastModified, 'full')}>{getKzDateTime(lastModified, 'time')}</time>
          </span>
          : null
        }
      </div>
    </Fragment>
  );
};
